export const getCroppedLogoUrl = (originalUrl: string): string => {
    if (!originalUrl) return originalUrl;

    const cleanUrl = originalUrl.replace(/^https?:\/\//, "");

    const params = new URLSearchParams({
        url: cleanUrl,
        trim: "5",
        output: "png",
    });

    return `https://wsrv.nl/?${params.toString()}`;
};